import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Trans, withTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import { DatePicker } from "@material-ui/pickers";
import TaxonomySelector from "./../taxonomy/TaxonomySelector";
import TextField from "@material-ui/core/TextField";

const styles = (theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  sortByContainer: {
    display: "flex",
    width: "100%",
  },
  sortBy: {
    flex: 0.3,
  },
  datesContainer: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    "& > *": {
      margin: 5,
    },
  },
  sortByLabel: {
    marginTop: 8,
    marginRight: 10,
  },
  formControl: {
    minWidth: 182,
  },
  chipInput: {
    margin: 5,
  },
  selectMargin: {
    marginTop: 16,
    marginLeft: 5,
    marginRight: 5,
    minWidth: 182,
  },
  userChipsWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
});

export class FilterSearches extends Component {
  state = {
    expanded: "basic",
    filter: {
      sortType: "none",
      sortOrder: "ASC",
      expert: "",
      resolved: "",
      createdBefore: null,
      createdAfter: null,
      taxonomyDialogOpen: false,
      taxonomyNode: { name: "" },
      searchText: "",
    },
  };
  componentDidUpdate(_prevProps, prevState) {
    if (prevState.filter !== this.state.filter) {
      this.onFilterChange();
    }
  }
  componentDidMount() {
    this.setupFilter(this.props.filter);
  }
  handleExpansionPanelChange = (panel) => (_event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  handleSortTypeChange = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        sortType: e.target.value,
      },
    });
  };

  handleTextFieldChange = (name) => (event) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [name]: event.target.value,
      },
    });
  };

  handleCheckboxChange = (name) => (event) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [name]: event.target.checked,
      },
    });
  };

  handleDateChange = (name) => (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [name]: e,
      },
    });
  };

  handleSelectChange = (event) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [event.target.name]: event.target.value,
      },
    });
  };

  render() {
    const { classes, t } = this.props;
    const { expanded } = this.state;
    return (
      <div>
        {this.props.showReset && (
          <Button
            className={classes.resetButton}
            onClick={this.resetToDefaultFilters}
          >
            <Trans i18nKey="filters_reset_to_default" />
          </Button>
        )}
        <ExpansionPanel
          expanded={expanded === "sort"}
          onChange={this.handleExpansionPanelChange("sort")}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>
              <Trans i18nKey="global_sort" />
            </Typography>
            <Typography className={classes.secondaryHeading}>
              <Trans i18nKey="filter_documents_sort_secondary_heading" />
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className={classes.sortByContainer}>
              <Typography className={classes.sortByLabel}>
                Sort by...
              </Typography>
              <FormControl className={classes.sortBy}>
                <Select
                  value={this.state.filter.sortType}
                  onChange={this.handleSortTypeChange}
                  inputProps={{
                    name: "sort-type",
                    id: "sort-type",
                  }}
                >
                  <MenuItem value="none">
                    <Trans i18nKey="filter_discussions_sort_none" />
                  </MenuItem>
                  <MenuItem value="alphabetical">
                    <Trans i18nKey="global_sort_text_alphabetical" />
                  </MenuItem>
                  <MenuItem value="dateCreated">
                    <Trans i18nKey="global_filter_created_date" />
                  </MenuItem>
                </Select>
              </FormControl>
              <Button onClick={this.toggleSortOrder}>
                {this.state.filter.sortOrder === "ASC" ? (
                  <>
                    <ArrowUpwardIcon /> <Trans i18nKey="ascending" />
                  </>
                ) : (
                  <>
                    <ArrowDownwardIcon />
                    <Trans i18nKey="descending" />
                  </>
                )}
              </Button>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={expanded === "basic"}
          onChange={this.handleExpansionPanelChange("basic")}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>
              <Trans i18nKey="global_basic" />
            </Typography>
            <Typography className={classes.secondaryHeading}>
              <Trans i18nKey="filter_searches_basic_secondary_heading" />
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl>
              <TextField
                id="searchText"
                label={t("filter_searches_search_text")}
                className={classes.textField}
                value={
                  this.state.filter.searchText
                    ? this.state.filter.searchText
                    : ""
                }
                onChange={this.handleTextFieldChange("searchText")}
                name="searchText"
                margin="normal"
              />
            </FormControl>

            {/* <FormControl className={classes.selectMargin}>
              <InputLabel shrink htmlFor="resolved">
                <Trans i18nKey="global_resolve_past_tense"></Trans>
              </InputLabel>
              <Select
                value={this.state.filter.resolved}
                onChange={this.handleSelectChange}
                inputProps={{
                  name: "resolved",
                  id: "resolved",
                }}
              >
                <MenuItem value="">
                  <Trans i18nKey="filter_discussions_all"></Trans>
                </MenuItem>
                <MenuItem value="1">
                  <Trans i18nKey="filter_searches_resolved_only"></Trans>
                </MenuItem>
                <MenuItem value="0">
                  <Trans i18nKey="filter_searches_not_resolved_only"></Trans>
                </MenuItem>
              </Select>
            </FormControl> */}

            {/* <FormControl className={classes.selectMargin}>
              <InputLabel shrink htmlFor="expert">
                <Trans i18nKey="global_expert"></Trans>
              </InputLabel>
              <Select
                value={this.state.filter.expert}
                onChange={this.handleSelectChange}
                inputProps={{
                  name: "expert",
                  id: "expert",
                }}
              >
                <MenuItem value="">
                  <Trans i18nKey="filter_discussions_all"></Trans>
                </MenuItem>
                <MenuItem value="1">
                  <Trans i18nKey="filter_discussions_expert_only"></Trans>
                </MenuItem>
                <MenuItem value="0">
                  <Trans i18nKey="filter_discussions_non_expert_only"></Trans>
                </MenuItem>
              </Select>
            </FormControl> */}
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={expanded === "dates"}
          onChange={this.handleExpansionPanelChange("dates")}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>
              <Trans i18nKey="global_sort_dates" />
            </Typography>
            <Typography className={classes.secondaryHeading}>
              <Trans i18nKey="filter_searches_dates_secondary_heading" />
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className={classes.datesContainer}>
              <DatePicker
                autoOk
                label={t("filter_discussions_created_before")}
                clearable
                disableFuture
                value={this.state.filter.createdBefore}
                onChange={this.handleDateChange("createdBefore")}
              />
              <DatePicker
                autoOk
                label={t("filter_discussions_created_after")}
                clearable
                disableFuture
                value={this.state.filter.createdAfter}
                onChange={this.handleDateChange("createdAfter")}
              />
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        {/* <ExpansionPanel
          expanded={expanded === "sections"}
          onChange={this.handleExpansionPanelChange("sections")}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>
              <Trans i18nKey="global_section_plural"></Trans>
            </Typography>
            <Typography className={classes.secondaryHeading}>
              <Trans i18nKey="filter_searches_sections_secondary_heading"></Trans>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <TaxonomySelector
              filter={this.props.filter}
              onNodeSelected={this.props.setTaxonomy}
            />
          </ExpansionPanelDetails>
        </ExpansionPanel> */}
      </div>
    );
  }

  resetToDefaultFilters = () => {
    this.setState({ filter: JSON.parse(this.props.defaultFilters) });
  };

  setupFilter = (filter) => {
    if (filter.createdAfter) {
      filter.createdStart = filter.createdAfter.valueOf.toString();
    }
    if (filter.createdBefore) {
      filter.createdEnd = filter.createdBefore.valueOf.toString();
    }
    if (filter.lastModifiedBefore) {
      filter.modifiedStart = filter.lastModifiedBefore.valueOf.toString();
    }
    if (filter.lastModifiedAfter) {
      filter.modifiedEnd = filter.lastModifiedAfter.valueOf.toString();
    }
    // this.setState({ filter: filter });
    this.setState({
      filter: {
        ...this.state.filter,
        ...filter,
      },
    });
  };

  onFilterChange = () => {
    let filter = Object.assign({}, this.state.filter);

    if (filter.createdAfter) {
      filter.createdStart = filter.createdAfter.valueOf.toString();
    }
    if (filter.createdBefore) {
      filter.createdEnd = filter.createdBefore.valueOf.toString();
    }
    this.props.onFilterChange(filter);
  };

  addChip = (key, chip) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [key]: [...this.state[key], chip],
      },
    });
  };

  deleteChip = (key, chip) => {
    let filtered = this.state[key].filter((i) => i !== chip);
    this.setState({
      filter: {
        ...this.state.filter,
        [key]: filtered,
      },
    });
  };

  toggleSortOrder = () => {
    this.setState((prev) => {
      if (prev.sortOrder === "ASC") {
        return {
          filter: {
            ...this.state.filter,
            sortOrder: "DESC",
          },
        };
      }
      return {
        filter: {
          ...this.state.filter,
          sortOrder: "ASC",
        },
      };
    });
  };
}

export default withStyles(styles)(withTranslation()(FilterSearches));
